export default __webpack_public_path__ + "static/media/teacher_note_pin.3068d967.svg";